import { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ReactApexChart from "react-apexcharts";
import CircleProgressSmall from "./circleProgressSmall";
import { Button, message, Modal } from "antd";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import { getEmployeeById, getEmployeeByUserId, } from "../../../core/data/redux/employee/employeeAction";
import Webcam from "react-webcam";
import { createPunch, getPunchByEmployeeId, } from "../../../core/data/redux/attendance/punch/punchAction";
import { getCurrentLocation } from "../../../core/common/GlobalFunctions/currentLocation";
import { getGreeting } from "../../../core/common/GlobalFunctions/greetingByTIme";
import { fetchProjectByEmployeeId } from "../../../core/data/redux/projects/project/projectAction";
import { fetchEmployeePunchStats, fetchEmployeeStats, } from "../../../core/data/redux/dashboards/admindashboard/adminDashboardActions";
import LeaveRequestModal from "../../hrm/attendance/leaves/leaveRequestModal";
import { fetchTasksByEmployeeId } from "../../../core/data/redux/projects/task/taskActions";
import { fetchAllHolidays, fetchNextUpcomingHoliday } from "../../../core/data/redux/holiday/holidayAction";
import dayjs, { Dayjs } from "dayjs";
import { fetchEmployeeTime } from "../../../core/data/redux/reports/attendance_report/attendacnereport.Action";
import { fetchAllLeaveCountByEmployeeId } from "../../../core/data/redux/reports/leave_reports/leavereports.Action";
import { useAppConfig } from "../../../customhooks/useAppConfig";
import { formatDate } from "../../../core/utils/configFormatters";
import { getBirthdayByDate } from "../../../core/data/redux/calendar/calendarAction";
import { fetchPolicyByEmployeeId, policy_log } from "../../../core/data/redux/policy/policyAction";
import { fetchSalaryTransactionsByEmployeeId } from "../../../core/data/redux/payroll/payrollSalary/salaryTransaction/salaryTransactionActions";
import PayslipModal from "../../finance-accounts/payroll/payslipModal";
import html2pdf from 'html2pdf.js';
import { createPayslip } from "../../../core/data/redux/payroll/payrollSalary/payslip/payslipActions";
import { fetchEmployeeLeaveAssignById } from "../../../core/data/redux/attendance/leave/leaveAction";
import { fetchAllocatedAssetsByEmployeeId } from "../../../core/data/redux/asset/assetAllocation/assetAllocationActions";
import { buildEmployeeWeeklyOffMap, isHolidayInRange, isWeeklyOffDate } from "../../hrm/attendance/weeklyOffUtils";
import { fetchAllWeekoff } from "../../../core/data/redux/weekoff/weekoff.Action";
import EmployeeDashTeam from "./employeeDashTeam";
const months = [
  { value: 0, label: 'January' },
  { value: 1, label: 'February' },
  { value: 2, label: 'March' },
  { value: 3, label: 'April' },
  { value: 4, label: 'May' },
  { value: 5, label: 'June' },
  { value: 6, label: 'July' },
  { value: 7, label: 'August' },
  { value: 8, label: 'September' },
  { value: 9, label: 'October' },
  { value: 10, label: 'November' },
  { value: 11, label: 'December' },
];


const currentYear = new Date().getFullYear();
const years = Array.from({ length: 10 }, (_, i) => currentYear - i);


const EmployeeDashboard = () => {
  const routes = all_routes;
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: any) => state.auth);
  const { employeesbyUser } = useSelector((state: any) => state.employee);
  const { projectByEmployeeId } = useSelector((state: any) => state.project.projects);
  const { employeeFullDetails } = useSelector((state: any) => state.employee);
  const { punches } = useSelector((state: any) => state.attendance.punch);
  const { assetAllocationsByEmployee } = useSelector((state: any) => state.asset.assetAllocation);
  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const [capturedImage, setCapturedImage] = useState<string | undefined | null>(undefined);
  const [getEmployeetime, setEmployeetime] = useState<any[]>([]);
  const [punchInTime, setPunchInTime] = useState<string | null>(null);
  const [duration, setDuration] = useState<string | null>(null);
  const [punchOutTime, setPunchOutTime] = useState<string | null>(null);
  const [isWebcamModalVisible, setIsWebcamModalVisible] = useState<boolean>(false);
  const [currentTime, setCurrentTime] = useState<string>("");
  const [webcamKey, setWebcamKey] = useState(0);
  const webcamRef = useRef<Webcam>(null);
  const [birthday, setbirthday] = useState<any>([]);
  const { employeeStats } = useSelector((state: any) => state.dashboard.adminDashboard);
  const { tasksByEmployee } = useSelector((state: any) => state.project.task);
  const { nextUpcomingHoliday } = useSelector((state: any) => state.holiday);
  const { birthdayEmployees } = useSelector((state: any) => state.dashboard.adminDashboard);
  const [leaveAnalytics, setLeaveAnalytics] = useState<any>([]);
  const employeeId = employeesbyUser?.employeeId;
  const [punchstats, setpunchstats] = useState<any>("")
  const [employeepolicy, setemployeepolicy] = useState<any>([])
  const { salaryTransactionsByEmployee = [] } = useSelector((state: any) => state.payroll.salaryTransaction);
  const [selectedMonth, setSelectedMonth] = useState<number>(new Date().getMonth());
  const [selectedYear, setSelectedYear] = useState<number>(currentYear);
  const [isPaySlipModalVisible, setIsPaySlipModalVisible] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [employeeassignleave, setemployeeassignleave] = useState<any>([])
  const [isPolicyViewerOpen, setIsPolicyViewerOpen] = useState(false);
  const [activePolicy, setActivePolicy] = useState<any>(null);
  const { policyLog } = useSelector((state: any) => state.policy);
  const { weekoff } = useSelector((state: any) => state.weekoff);
  const { holidays = [] } = useSelector((state: any) => state.holiday);


  const getDateRange = (start:any, end:any) => {
    const dates = [];
    let current = dayjs(start);

    while (current.isBefore(end) || current.isSame(end, "day")) {
      dates.push(current.format("DD MMM YYYY"));
      current = current.add(1, "day");
    }
    return dates;
  };


  // Weeklyoff
  useEffect(() => {
    dispatch(fetchAllWeekoff());
  }, [dispatch]);

  useEffect(() => {
    if (!holidays.length) {
      dispatch(fetchAllHolidays());
    }
  }, [dispatch, holidays.length]);

  const employeeWeeklyOffMap = useMemo(
    () => buildEmployeeWeeklyOffMap(weekoff, employeesbyUser),
    [weekoff, employeesbyUser]
  );

  const checkWeeklyOffRange = (fromDate: Dayjs, toDate: Dayjs) => {
    let current = fromDate.startOf("day");
    while (current.isSameOrBefore(toDate, "day")) {
      if (isWeeklyOffDate(current, employeeId, employeeWeeklyOffMap)) {
        return { isInvalid: true, type: "WeeklyOff" };
      }
      current = current.add(1, "day");
    }

    // 🔹 Check for holiday overlap
    if (isHolidayInRange(fromDate, toDate, holidays)) {
      return { isInvalid: true, type: "Holiday" };
    }

    return { isInvalid: false, type: "" };
  };
  const [view, setView] = useState("self");

  const getTotalLeaveQuantity = (data: any[]) => {
    if (!Array.isArray(data)) return 0;
    return data.reduce((sum, item) => sum + (item.LeaveQuantity || 0), 0);
  };
  const totalLeave = getTotalLeaveQuantity(employeeassignleave);

  const openPolicyViewer = (policy: any) => {
    if (!policy?.PolicyDocURL) return;
    setActivePolicy(policy);
    setIsPolicyViewerOpen(true);
  };

  const handlePolicyDownload = async (policy: any) => {
    try {
      await dispatch(policy_log({ policyId: policy.Id, employeeId: employeeId })).unwrap();

      const response = await fetch(policy.PolicyDocURL, { mode: "cors" });
      if (!response.ok) {
        throw new Error(`Failed to fetch file: ${response.statusText}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const extension = policy.PolicyDocURL.split(".").pop() || "pdf";
      const fileName = `${policy.Name || "policy_document"}.${extension}`;

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      message.success("Policy downloaded successfully.");
    } catch (error) {
      console.error("Download failed:", error);
      message.error("Failed to download the policy. Please try again.");
    }
  };

  // ✅ Close viewer
  const closePolicyViewer = () => {
    setIsPolicyViewerOpen(false);
    setActivePolicy(null);
  };

  const overlayGuardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isPolicyViewerOpen) return;

    requestAnimationFrame(() => overlayGuardRef.current?.focus());

    const onKey = (e: KeyboardEvent) => {
      const k = e.key.toLowerCase();
      if ((e.ctrlKey || e.metaKey) && (k === "p" || k === "s")) {
        e.preventDefault();
        e.stopPropagation();
        alert("Printing is disabled.");
      }
    };

    window.addEventListener("keydown", onKey, true);

    const style = document.createElement("style");
    style.setAttribute("data-policy-noprint", "true");
    style.innerHTML = `
    @media print {
      .policy-viewer, .policy-viewer * { display: none !important; }
    }
  `;
    document.head.appendChild(style);

    return () => {
      window.removeEventListener("keydown", onKey, true);
      document.head.querySelector('style[data-policy-noprint="true"]')?.remove();
    };
  }, [isPolicyViewerOpen]);

  const filteredTransactions = useMemo(() => {
    return salaryTransactionsByEmployee.filter((transaction: any) => {
      return (
        transaction.year === selectedYear &&
        new Date(transaction.payment_date).getMonth() === selectedMonth
      );
    });
  }, [salaryTransactionsByEmployee, selectedMonth, selectedYear]);

  const downloadPayslipAsPDF = (record: any) => {
    setSelectedRowData(record)
    setLoadingDownload(true);
    const element = document.getElementById('payslip-content');
    if (element) {
      const opt = {
        margin: 1,
        filename: 'payslip.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      };
      html2pdf().from(element).set(opt).save();
    }
  };

  const [selectedLeaveType, setSelectedLeaveType] = useState(
    employeeStats?.ApprovedLeaveByType
      ? Object.keys(employeeStats.ApprovedLeaveByType)[0]
      : ""
  );

  const [selectedLeavePeriod, setSelectedLeavePeriod] = useState("Monthly");
  const leaveTypes = Object.keys(employeeStats?.ApprovedLeaveByType || {});
  const leaveData = leaveTypes?.map((type) => ({
    label: type,
    month: employeeStats?.ApprovedLeaveByType?.[type]?.Month,
    year: employeeStats?.ApprovedLeaveByType?.[type]?.Year,
  }));
  const chartData = leaveTypes?.map((type) =>
    selectedLeavePeriod === "Monthly"
      ? employeeStats?.ApprovedLeaveByType?.[type]?.Month
      : employeeStats?.ApprovedLeaveByType?.[type]?.Year
  );

  useEffect(() => {
    if (employeeId) {
      dispatch(fetchEmployeeLeaveAssignById(employeeId))
        .then((res) => {
          setemployeeassignleave(res.payload.data)
        })
    }
  }, [dispatch])

  useEffect(() => {
    if (leaveTypes.length > 0 && !selectedLeaveType) {
      setSelectedLeaveType(leaveTypes[0]);
    }
  }, [leaveTypes, selectedLeaveType]);

  useEffect(() => {
    if (employeeId) {
      dispatch(fetchAllLeaveCountByEmployeeId(employeeId))
        .then((res) => {
          setLeaveAnalytics(res.payload.data);
        })
    }

  }, [dispatch, employeeId])

  useEffect(() => {
    if (employeeId) {
      dispatch(fetchSalaryTransactionsByEmployeeId(employeeId))
    }
  }, [dispatch, employeeId])

  useEffect(() => {
    if (employeeId) {
      dispatch(fetchAllocatedAssetsByEmployeeId(employeeId))
    }
  }, [dispatch, employeeId])

  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [modalType, setModalType] = useState<"edit" | "create" | "">("");

  const showModal = (type: "edit" | "create") => {
    setModalType(type);
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setModalType("");
  };

  const today = new Date().toISOString().split("T")[0];
  const lastPunch = punches.find((punch: any) =>
    punch.PunchIn?.startsWith(today)
  );
  const nextAction = lastPunch?.nextAction || 'IN';

  const stopCamera = () => {
    if (webcamRef.current) {
      const videoElement = webcamRef.current.video;
      if (videoElement?.srcObject) {
        const stream = videoElement.srcObject as MediaStream;
        stream.getTracks().forEach((track) => track.stop());
        videoElement.srcObject = null;
      }
    }
  };

  useEffect(() => {
    if (user?.UserId) {
      dispatch(getEmployeeByUserId({ userId: user?.UserId }));
    }
  }, [dispatch, user?.UserId]);

  useEffect(() => {
    if (employeeId) {
      dispatch(getEmployeeById({ employeeId }));
    }
  }, [dispatch, employeeId]);

  useEffect(() => {
    if (employeeFullDetails) {
      const departmentId = employeeFullDetails?.employee[0]?.DepartmentId;
      const gender = employeeFullDetails?.employee[0]?.GenderId;
      const branch = employeeFullDetails?.employee[0]?.branch;
      dispatch(fetchPolicyByEmployeeId({ employeeId, departmentId, branch, gender }))
        .then((res) => {
          setemployeepolicy(res.payload.data)
        })
    }
  }, [employeeFullDetails, dispatch])

  // 3. Fetch Employee Tasks
  useEffect(() => {
    if (employeeId) {
      dispatch(fetchTasksByEmployeeId(employeeId));
    }
  }, [dispatch, employeeId]);

  // 4. Fetch Projects by Employee
  useEffect(() => {
    if (employeeId) {
      dispatch(fetchProjectByEmployeeId({ employeeId }));
    }
  }, [dispatch, projectByEmployeeId.length, employeeId]);

  // 5. Fetch Employee Stats
  useEffect(() => {
    if (employeeId) {
      dispatch(fetchEmployeeStats(employeeId));
    }
  }, [dispatch, employeeId]);

  // useEffect(() => {
  //   if (birthdayEmployees?.length === 0) {
  //     dispatch(fetchEmployeesWithBirthdayToday());
  //   }
  // }, [dispatch, birthdayEmployees?.length]);

  //?employee=138&departmentId=21&branch=2&gender=

  useEffect(() => {
    dispatch(fetchNextUpcomingHoliday());
    function getTodayMonthDay() {
      const today = new Date();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${month}-${day}`;
    }

    const todayMMDD = getTodayMonthDay();
    dispatch(getBirthdayByDate(todayMMDD)).then((res) => {
      setbirthday(res.payload.data);
    });
  }, [dispatch]);

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = `${today.getMonth() + 1}`.padStart(2, "0");
    const day = `${today.getDate()}`.padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const todayDate = getTodayDate();

  useEffect(() => {
    if (employeeId) {
      dispatch(
        fetchEmployeeTime({ employeeId: employeeId, date: todayDate })
      ).then((res) => {
        if (res.payload?.data) {
          setEmployeetime(res.payload.data);
        } else {
          setEmployeetime([]);
        }
      });
    }
    if (employeeId) {
      dispatch(fetchEmployeePunchStats(employeeId))
        .then((res) => {
          setpunchstats(res.payload.data)
        })
    }

  }, [dispatch, user?.UserId, employeeId]);

  const base64ToFile = (base64String: string, filename: string): File => {
    const byteString = atob(base64String.split(",")[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }
    return new File([uint8Array], filename, { type: "image/jpeg" });
  };

  const formatTime = (date: Date) =>
    date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

  const calculateDuration = (punchInDate: Date, punchOutDate: Date) => {
    const durationInSeconds =
      Math.abs(punchOutDate.getTime() - punchInDate.getTime()) / 1000;
    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);
    const seconds = Math.floor(durationInSeconds % 60);
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };

  const handlePunchIn = async (capturedFile: File) => {
    const { latitude, longitude } = await getCurrentLocation();
    const punchData = {
      EmployeeId: employeeId,
      PunchDate: new Date().toISOString(),
      PunchTime: new Date().toISOString(),
      Longitude: longitude,
      Latitude: latitude,
      PunchType: "IN",
      CreatedBy: user?.UserId,
      file: capturedFile,
      EmployeeCode: employeesbyUser?.employeeNumber,
    };
    await dispatch(createPunch(punchData));
    await dispatch(getPunchByEmployeeId(employeesbyUser?.employeeNumber));
    if (employeeId) {
      dispatch(fetchEmployeePunchStats(employeeId))
        .then((res) => {
          setpunchstats(res.payload.data)
        })
      dispatch(fetchEmployeeTime({ employeeId: employeeId, date: todayDate })).then((res) => {
        if (res.payload?.data) {
          setEmployeetime(res.payload.data);
        } else {
          setEmployeetime([]);
        }
      });
    }
  };

  const captureImage = () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      if (imageSrc) {
        const imageFile = base64ToFile(imageSrc, "captured-image.jpg");
        setCapturedImage(imageSrc);
        stopCamera();
        setIsWebcamModalVisible(false);
        handlePunchIn(imageFile);
      }
    }
  };

  const captureCheckoutImage = () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      if (imageSrc) {
        const imageFile = base64ToFile(imageSrc, "checkout-image.jpg");
        setCapturedImage(imageSrc);
        stopCamera();
        setIsWebcamModalVisible(false);
        handleCheckout(imageFile);
      }
    }
  };

  const handleCheckout = async (capturedFile: File) => {
    const { latitude, longitude } = await getCurrentLocation();
    if (!lastPunch || !lastPunch.Id) {
      alert("No active punch-in record found.");
      return;
    }

    const punchOutTime = new Date().toISOString();
    const punchInDate = new Date(lastPunch.PunchIn);
    const punchOutDate = new Date(punchOutTime);
    const duration = calculateDuration(punchInDate, punchOutDate);

    const updateData = {
      EmployeeId: employeeId,
      PunchDate: new Date().toISOString(),
      PunchTime: new Date().toISOString(),
      Longitude: longitude,
      Latitude: latitude,
      CreatedBy: user?.UserId,
      PunchType: "OUT",
      file: capturedFile,
      EmployeeCode: employeesbyUser?.employeeNumber,
    };
    await dispatch(createPunch(updateData));
    await dispatch(getPunchByEmployeeId(employeesbyUser?.employeeNumber));
    if (employeeId) {
      dispatch(fetchEmployeePunchStats(employeeId))
        .then((res) => {
          setpunchstats(res.payload.data)
        })
      dispatch(fetchEmployeeTime({ employeeId: employeeId, date: todayDate })).then((res) => {
        if (res.payload?.data) {
          setEmployeetime(res.payload.data);
        } else {
          setEmployeetime([]);
        }
      });
    }
  };

  useEffect(() => {
    if (employeesbyUser?.employeeNumber && punches.length === 0) {
      dispatch(getPunchByEmployeeId(employeesbyUser?.employeeNumber));
    } else if (lastPunch) {
      const punchInDate = new Date(lastPunch.PunchIn);
      const punchOutDate = lastPunch.PunchOut
        ? new Date(lastPunch.PunchOut)
        : null;
      const formattedTime = formatTime(punchInDate);
      const formattedOutTime = punchOutDate ? formatTime(punchOutDate) : null;

      setPunchInTime(formattedTime);
      setPunchOutTime(formattedOutTime);
      if (lastPunch.CheckInImagePath) {
        setPreviewImage(lastPunch.CheckInImagePath);
      }
      if (punchOutDate) {
        const duration = calculateDuration(punchInDate, punchOutDate);
        setDuration(duration);
      }
    }
  }, [punches, dispatch, employeeId, lastPunch]);

  const showWebcamModal = () => {
    setCapturedImage(null);
    setIsWebcamModalVisible(true);
    setWebcamKey((prevKey) => prevKey + 1);
  };

  const handleWebcamCancel = () => {
    stopCamera();
    setIsWebcamModalVisible(false);
    setCapturedImage(null);
  };

  const [date, setDate] = useState(new Date("2024"));

  //New Chart
  const leavesChart: any = useMemo(() => {
    return {
      chart: {
        height: 165,
        type: "donut" as const,
        toolbar: {
          show: false,
        },
      },
      labels: leaveTypes,
      plotOptions: {
        pie: {
          donut: {
            donutWidth: "50%",
            offsetY: 0,
          },
        }
      },
      dataLabels: {
        enabled: false,
      },
      series: leaveTypes?.map(
        (type) => employeeStats?.ApprovedLeaveByType?.[type]?.Month || 0
      ),
      colors: ["#F26522", "#FFC107", "#E70D0D", "#03C95A", "#0C4B5E"],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              show: false,
            },
          },
        },
      ],
      legend: {
        show: true,
        position: "bottom",
        markers: {
          width: 16,
          height: 16,
        },
        itemMargin: {
          horizontal: 5,
          vertical: 5,
        },
        onItemClick: {
          toggleDataSeries: true,
        },
        labels: {
          useSeriesColors: true,
          formatter: function (val: string, opts: any) {
            return leaveTypes[opts.seriesIndex];
          },
        },
      },
      tooltip: {
        enabled: true,
        shared: true,
        intersect: false,
        custom: function ({
          seriesIndex,
          series,
        }: {
          seriesIndex: number;
          series: any[];
        }) {
          return `<div class="arrow_box">
                  <span class="leave-type">${leaveTypes[seriesIndex]}</span>: <strong>${series[seriesIndex]}</strong> ${selectedLeavePeriod} Leaves
                </div>`;
        },
      },
    };
  }, [leaveTypes, employeeStats, selectedLeavePeriod]);

  const [performance_chart2] = useState<any>({
    series: [
      {
        name: "performance",
        data: [20, 20, 35, 35, 40, 60, 60],
      },
    ],
    chart: {
      height: 288,
      type: "area",
      zoom: {
        enabled: false,
      },
    },
    colors: ["#03C95A"],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "straight",
    },
    title: {
      text: "",
      align: "left",
    },
    xaxis: {
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
    },
    yaxis: {
      min: 10,
      max: 60,
      tickAmount: 5,
      labels: {
        formatter: (val: number) => {
          return val / 1 + "K";
        },
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
    },
  });

  const employeename = [
    { value: "Select", label: "Select" },
    { value: "Anthony Lewis", label: "Anthony Lewis" },
    { value: "Brian Villalobos", label: "Brian Villalobos" },
    { value: "Harvey Smith", label: "Harvey Smith" },
  ];
  const leaveType = [
    { value: "Select", label: "Select" },
    { value: "Medical Leave", label: "Medical Leave" },
    { value: "Casual Leave", label: "Casual Leave" },
    { value: "Annual Leave", label: "Annual Leave" },
  ];

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };

  const config = useAppConfig();
  if (!config) return null

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">{view === "self" ? "Employee Dashboard" : "Team Dashboard"}</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Dashboard</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {view === "self" ? "Employee Dashboard" : "Team Dashboard"}
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap gap-4">
              <div className="form-check form-switch me-3" style={{ transform: "scale(1.4)", transformOrigin: "left center" }}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="viewSwitch"
                  onChange={(e) => setView(e.target.checked ? "team" : "self")}
                />
                <label className="form-check-label ms-2 fw-semibold" htmlFor="viewSwitch">
                  {view === "self" ? "Self" : "Team"}
                </label>
              </div>
              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {view === "self" ? (
            <>
              <div className="row">
                <div className="col-xl-4 d-flex">
                  <div className="card position-relative flex-fill">
                    <div className="card-header bg-dark">
                      <div className="d-flex align-items-center">
                        <Link to={`${all_routes.employeedetails.replace(
                          ":employeeId",
                          btoa(employeeFullDetails?.employee[0]?.EmployeeID.toString())
                        )}`}>
                          <span className="avatar avatar-lg avatar-rounded border border-white border-2 flex-shrink-0 me-2">
                            <img src={employeeFullDetails?.employee[0]?.PictureURL ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"} alt="Img" />
                          </span>
                        </Link>
                        <div>
                          <h5 className="text-white mb-1">
                            {employeeFullDetails?.employee[0]?.Name}
                          </h5>
                          <div className="d-flex align-items-center">
                            <p className="text-white fs-12 mb-0">
                              {employeeFullDetails?.employee[0]?.designation_name ||
                                "N/A"}
                            </p>
                            <span className="mx-1">
                              <i className="ti ti-point-filled text-primary" />
                            </span>
                            <p className="fs-12">
                              {employeeFullDetails?.employee[0]?.department_name ||
                                "N/A"}
                            </p>
                          </div>
                        </div>
                      </div>
                      {/* <Link
                    to="#"
                    className="btn btn-icon btn-sm text-white rounded-circle edit-top"
                  >
                    <i className="ti ti-edit" />
                  </Link> */}
                    </div>
                    <div className="card-body">
                      <div className="mb-3">
                        <span className="d-block mb-1 fs-13">Phone Number</span>
                        <p className="text-gray-9">
                          {employeeFullDetails?.employee[0]?.Phone || "N/A"}
                        </p>
                      </div>
                      <div className="mb-3">
                        <span className="d-block mb-1 fs-13">Email Address</span>
                        <p className="text-gray-9">
                          {employeeFullDetails?.employee[0]?.Email || "N/A"}
                        </p>
                      </div>
                      <div className="mb-3">
                        <span className="d-block mb-1 fs-13">Reporting person</span>
                        {employeeFullDetails?.employee[0]?.supervisor_name || "N/A"}
                      </div>
                      <div>
                        <span className="d-block mb-1 fs-13">Joined on</span>
                        <p className="text-gray-9">
                          {employeeFullDetails?.employee[0]?.DateOfJoining
                            ? formatDate(employeeFullDetails?.employee[0]?.DateOfJoining, config) : "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-5 d-flex">
                  <div className="card flex-fill">
                    <div className="card-header">
                      <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                        <h5>Leave Details</h5>
                        <div className="d-flex">
                          {/* Dropdown for selecting leave type */}
                          <select
                            className="form-select"
                            value={selectedLeaveType}
                            onChange={(e) => setSelectedLeaveType(e.target.value)}
                          >
                            {leaveTypes?.map((type) => (
                              <option key={type} value={type}>
                                {type}
                              </option>
                            ))}
                          </select>

                          {/* Dropdown for selecting leave period (Monthly/Yearly) */}
                          <select
                            className="form-select ms-2"
                            value={selectedLeavePeriod}
                            onChange={(e) => setSelectedLeavePeriod(e.target.value)}
                          >
                            <option value="Monthly">Monthly</option>
                            <option value="Yearly">Yearly</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-md-6">
                          <div className="mb-4 ">
                            {/* Dynamic leave details for selected leave type */}
                            {leaveData?.map(
                              (leave) =>
                                selectedLeaveType === leave.label && (
                                  <div
                                    key={leave.label}
                                    className="card p-3 mb-3 shadow-sm"
                                  >
                                    <div className="card-body">
                                      <h5 className="card-title text-center mb-3">
                                        {leave.label}{" "}
                                        {/* Display the leave label */}
                                      </h5>
                                      <div className="d-flex flex-column align-items-center">
                                        <p className="fs-2 text-dark mb-1">
                                          {selectedLeavePeriod === "Monthly"
                                            ? leave.month
                                            : leave.year}{" "}
                                          {/* Display the data (Month or Year) */}
                                        </p>

                                        <p className="text-center text-muted small mb-0">
                                          {leave.label} of {selectedLeavePeriod}{" "}
                                          {/* Display additional information */}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                )
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-4 d-flex justify-content-center">
                            <ReactApexChart
                              id="leaves_chart"
                              options={leavesChart}
                              series={leavesChart.series}
                              type="donut"
                              height={165}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 d-flex">
                  <div className="card flex-fill">
                    <div className="card-header">
                      <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                        <h5>Leave Details</h5>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-sm-6">
                          <div className="mb-3">
                            <span className="d-block mb-1">Applied</span>
                            <h4>{Number(leaveAnalytics[0]?.Total)}</h4>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="mb-3">
                            <span className="d-block mb-1">Approved</span>
                            <h4>{Number(leaveAnalytics[0]?.Approved)}</h4>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="mb-3">
                            <span className="d-block mb-1">Rejected</span>
                            <h4>{Number(leaveAnalytics[0]?.Rejected)}</h4>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="mb-3">
                            <span className="d-block mb-1">Pending</span>
                            <h4>{Number(leaveAnalytics[0]?.Pending)}</h4>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="mb-3">
                            <span className="d-block mb-1">Total Balance</span>
                            <h4>{totalLeave ? totalLeave : 0}</h4>
                          </div>
                        </div>
                        {/* You can add placeholders or real data for below if needed */}

                        <div className="col-sm-12" style={{ marginTop: "80px" }}>
                          <div>
                            <button
                              className="btn btn-dark w-100"
                              onClick={() => showModal("create")}
                            >
                              Apply New Leave
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div className="row">
                <div className="col-xl-4 d-flex">
                  <div className="card flex-fill border-primary attendance-bg">
                    <div className="card-body">
                      <div className="mb-3 text-center">
                        <h6 className="fw-medium text-gray-5 mb-2">
                          {getGreeting()}, {lastPunch?.Name}
                        </h6>
                        <h4>{currentTime}</h4>
                      </div>
                      <div className="attendance-circle-progress mx-auto mb-3">
                        <div className="avatar avatar-xxl avatar-rounded">
                          <img
                            src={capturedImage || previewImage || "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                            alt="Profile Preview"
                            className="avatar-img"
                            style={{
                              width: "140px",
                              height: "120px",
                              objectFit: "cover",
                              borderRadius: "50%",
                            }}
                          />
                        </div>
                      </div>
                      <div className="text-center d-flex flex-column justify-content-between">
                        <div className="badge badge-md badge-primary mb-3">
                          Productive :: {getEmployeetime?.[0]?.ProductiveTime || "00:00"}
                        </div>
                        <h6 className="fw-medium d-flex align-items-center justify-content-center mb-3">
                          <i className="ti ti-fingerprint text-primary me-1" />
                          {punchInTime
                            ? `Check In at ${punchInTime}`
                            : "Check In time not available"}
                        </h6>
                        <h6 className="fw-medium d-flex align-items-center justify-content-center mb-3">
                          <i className="ti ti-fingerprint text-primary me-1" />
                          {lastPunch && lastPunch.PunchOut
                            ? `Check Out at ${punchOutTime}`
                            : "Check Out time not available"}
                        </h6>
                        <Link
                          to="#"
                          className="btn btn-dark w-100 mt-4"
                          onClick={showWebcamModal}
                        >
                          {nextAction === 'OUT' ? 'Checkout' : 'Check In'}
                        </Link>
                      </div>
                    </div>
                  </div>
                  <Modal
                    visible={isWebcamModalVisible}
                    onCancel={handleWebcamCancel}
                    footer={null}
                    width={400}
                    title="Capture Image"
                  >
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <Webcam
                        key={webcamKey}
                        ref={webcamRef}
                        audio={false}
                        screenshotFormat="image/jpeg"
                        width="100%"
                        videoConstraints={{ facingMode: "user" }}
                      />
                    </div>
                    <Button
                      type="primary"
                      onClick={nextAction === 'OUT' ? captureCheckoutImage : captureImage}
                      className="mt-2"
                    >
                      Submit
                    </Button>
                  </Modal>
                </div>
                <div className="col-xl-8 d-flex">
                  <div className="row flex-fill">
                    <div className="d-flex flex-wrap gap-2">
                      {/* Today Hours */}
                      <div className="card" style={{ flex: '0 0 calc(50% - 0.5rem)', height: '100px' }}>
                        <div className="card-body py-2 px-3">
                          <div className="d-flex align-items-center h-100">
                            <span className="avatar avatar-sm bg-primary me-3">
                              <i className="ti ti-clock-stop" />
                            </span>
                            <div>
                              <h5 className="mb-1 fs-16 text-gray-5">
                                {punchstats ? punchstats?.punchStats[0]?.today_duration : "0"}/
                                {punchstats ? punchstats?.shiftStats[0]?.today_hours : "0"}
                              </h5>
                              <p className="mb-0 text-muted small">Today Hours</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Week Hours */}
                      <div className="card" style={{ flex: '0 0 calc(50% - 0.5rem)', height: '100px' }}>
                        <div className="card-body py-2 px-3">
                          <div className="d-flex align-items-center h-100">
                            <span className="avatar avatar-sm bg-dark me-3">
                              <i className="ti ti-clock-up" />
                            </span>
                            <div>
                              <h5 className="mb-1 fs-16 text-gray-5">
                                {punchstats ? punchstats?.punchStats[0]?.week_duration : "0"}/
                                {punchstats ? punchstats?.shiftStats[0]?.week_hours : "0"}
                              </h5>
                              <p className="mb-0 text-muted small">Week Hours</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Month Hours */}
                      <div className="card" style={{ flex: '0 0 calc(50% - 0.5rem)', height: '100px' }}>
                        <div className="card-body py-2 px-3">
                          <div className="d-flex align-items-center h-100">
                            <span className="avatar avatar-sm bg-info me-3">
                              <i className="ti ti-calendar-up" />
                            </span>
                            <div>
                              <h5 className="mb-1 fs-16 text-gray-5">
                                {punchstats ? punchstats?.punchStats[0]?.month_duration : "0"}/
                                {punchstats ? punchstats?.shiftStats[0]?.month_hours : "0"}
                              </h5>
                              <p className="mb-0 text-muted small">Month Hours</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Overtime this Month */}
                      <div className="card" style={{ flex: '0 0 calc(50% - 0.5rem)', height: '100px' }}>
                        <div className="card-body py-2 px-3">
                          <div className="d-flex align-items-center h-100">
                            <span className="avatar avatar-sm bg-pink me-3">
                              <i className="ti ti-calendar-star" />
                            </span>
                            <div>
                              <h5 className="mb-1 fs-16 text-gray-5">
                                {employeeStats?.OvertimeThisMonth || "0"}
                              </h5>
                              <p className="mb-0 text-muted small">Overtime this Month</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-4">
                              <div className="mb-3 text-center">
                                <p className="d-flex align-items-center justify-content-center mb-1">
                                  <i className="ti ti-point-filled text-dark-transparent me-1" />
                                  Total Working hours
                                </p>
                                <h3>
                                  {getEmployeetime?.[0]?.TotalWorkingHours || "00:00"}
                                </h3>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="mb-3 text-center">
                                <p className="d-flex align-items-center justify-content-center mb-1">
                                  <i className="ti ti-point-filled text-success me-1" />
                                  Productive Hours
                                </p>
                                <h3>
                                  {getEmployeetime?.[0]?.ProductiveTime || "00:00"}
                                </h3>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="mb-3 text-center">
                                <p className="d-flex align-items-center justify-content-center mb-1">
                                  <i className="ti ti-point-filled text-warning me-1" />
                                  Break Hours
                                </p>
                                <h3>{getEmployeetime?.[0]?.BreakTime || "00:00"}</h3>
                              </div>
                            </div>
                          </div>

                          {/* Dynamic Progress Bar */}
                          <div className="row">
                            <div className="col-md-12">
                              <div
                                className="progress bg-light mb-3"
                                style={{ height: 24 }}
                              >
                                {(() => {
                                  const timeToMinutes = (timeStr: any) => {
                                    const [h, m] = (timeStr || "00:00")
                                      .split(":")
                                      ?.map(Number);
                                    return h * 60 + m;
                                  };

                                  const total = timeToMinutes(
                                    getEmployeetime?.[0]?.TotalWorkingHours
                                  );
                                  const productive = timeToMinutes(
                                    getEmployeetime?.[0]?.ProductiveTime
                                  );
                                  const breakTime = timeToMinutes(
                                    getEmployeetime?.[0]?.BreakTime
                                  );
                                  const productivePercent = total
                                    ? (productive / total) * 100
                                    : 0;
                                  const breakPercent = total
                                    ? (breakTime / total) * 100
                                    : 0;

                                  return (
                                    <>
                                      <div
                                        className="progress-bar bg-success rounded-start"
                                        role="progressbar"
                                        style={{ width: `${productivePercent}%` }}
                                        title={`Productive Time (${productivePercent.toFixed(
                                          1
                                        )}%)`}
                                      />
                                      <div
                                        className="progress-bar bg-warning rounded-end"
                                        role="progressbar"
                                        style={{ width: `${breakPercent}%` }}
                                        title={`Break Time (${breakPercent.toFixed(
                                          1
                                        )}%)`}
                                      />
                                    </>
                                  );
                                })()}
                              </div>
                            </div>

                            {/* Optional: Time Markers */}
                            <div className="col-md-12">
                              <div className="d-flex justify-content-between fs-10">
                                <span>Day Start</span>
                                <span>Day Finish</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-12 col-md-12 col-12 row ms-1">
                <div className="card flex-fill">
                  {/* Header with dropdowns and action buttons */}
                  <div className="card-header">
                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                      <h5 className="mb-0">Payslip Actions</h5>

                      <div className="d-flex align-items-center">
                        {/* Month Select */}
                        <select
                          className="form-select me-2"
                          style={{ minWidth: 120 }}
                          value={selectedMonth}
                          onChange={(e) => setSelectedMonth(Number(e.target.value))}
                        >
                          {months?.map((month) => (
                            <option key={month.value} value={month.value}>
                              {month.label}
                            </option>
                          ))}
                        </select>

                        {/* Year Select */}
                        <select
                          className="form-select me-3"
                          style={{ minWidth: 100 }}
                          value={selectedYear}
                          onChange={(e) => setSelectedYear(Number(e.target.value))}
                        >
                          {years?.map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>

                        {/* Only show if there are filtered transactions */}
                        {filteredTransactions.length > 0 && (
                          <>
                            {/* Download */}
                            <span
                              className="badge bg-success d-flex align-items-center justify-content-center py-2 me-2"
                              style={{ cursor: 'pointer' }}
                              onClick={() => downloadPayslipAsPDF(filteredTransactions[0])}
                              title="Download Payslip"
                            >
                              <i className="fas fa-download" />
                            </span>

                            {/* View */}
                            <span
                              className="badge bg-primary d-flex align-items-center justify-content-center py-2"
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                setSelectedRowData(filteredTransactions[0]);
                                setIsPaySlipModalVisible(true);
                              }}
                              title="View Payslip"
                            >
                              <i className="fas fa-eye" />
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Body with alert if no data */}
                  {filteredTransactions.length === 0 && (
                    <div className="card-body">
                      <div className="alert alert-warning mb-0" role="alert">
                        Please contact HR. Your salary slip has not been generated for this month.
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-xl-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-header">
                      <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                        <h5>Projects</h5>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        {projectByEmployeeId?.map((project: any) => (
                          <div key={project.project_id} className="col-md-6">
                            <div className="card mb-4 shadow-none mb-md-0">
                              <div className="card-body">
                                <div>
                                  <div className="d-flex align-items-center mb-3">
                                    <Link to="#" className="avatar">
                                      <img
                                        src={project.team_lead_pictureurl ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                                        className="img-fluid rounded-circle"
                                        alt="Team Lead"
                                      />
                                    </Link>
                                    <div className="ms-2">
                                      <h6 className="fw-normal">
                                        <Link to="#">{project.team_lead_name}</Link>
                                      </h6>
                                      <span className="fs-13 d-block">
                                        Project Leader
                                      </span>
                                    </div>
                                  </div>
                                  <div className="d-flex align-items-center mb-3">
                                    <Link
                                      to="#"
                                      className="avatar bg-soft-primary rounded-circle"
                                    >
                                      <i className="ti ti-calendar text-primary fs-16" />
                                    </Link>
                                    <div className="ms-2">
                                      <h6 className="fw-normal">
                                        {formatDate(project.end_date, config)}
                                      </h6>
                                      <span className="fs-13 d-block">
                                        Deadline
                                      </span>
                                    </div>
                                  </div>
                                  <div className="d-flex align-items-center justify-content-between bg-transparent-light border border-dashed rounded p-2 mb-3">
                                    <div className="d-flex align-items-center">
                                      <span className="avatar avatar-sm bg-success-transparent rounded-circle me-1">
                                        <i className="ti ti-checklist fs-16" />
                                      </span>
                                      <p>
                                        Tasks:{" "}
                                        <span className="text-gray-9">
                                          {project.completed_tasks}
                                        </span>
                                        /{project.total_tasks}
                                      </p>
                                    </div>
                                    <div className="avatar-list-stacked avatar-group-sm">
                                      {project?.employee_pictures?.map(
                                        (imageUrl: any, index: number) => (
                                          <span
                                            key={index}
                                            className="avatar avatar-rounded"
                                          >
                                            <img
                                              className="border border-white"
                                              src={imageUrl ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                                              alt="Employee Avatar"
                                              title={project?.employee_names[index]}
                                            />
                                          </span>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-header">
                      <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                        <h5>Tasks</h5>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="list-group list-group-flush">
                        {tasksByEmployee?.map((task: any) => (
                          <div
                            key={task.TaskID}
                            className="list-group-item border rounded mb-3 p-2"
                          >
                            <div className="row align-items-center row-gap-3">
                              <div className="col-md-8">
                                <div className="todo-inbox-check d-flex align-items-center">
                                  <span>
                                    <i className="ti ti-grid-dots me-2" />
                                  </span>
                                  <div className="strike-info">
                                    <h4 className="fs-14 text-truncate">
                                      {task.Title}
                                    </h4>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="d-flex align-items-center justify-content-md-end flex-wrap row-gap-3">
                                  <span
                                    className={`badge ${task.Status === "OnHold"
                                      ? "bg-soft-pink"
                                      : "bg-transparent-purple"
                                      } d-inline-flex align-items-center me-2`}
                                  >
                                    <i className="fas fa-circle fs-6 me-1" />
                                    {task.Status}
                                  </span>
                                  <div className="d-flex align-items-center">
                                    <div className="avatar-list-stacked avatar-group-sm">
                                      {task?.assignedEmployees?.map(
                                        (employee: any) => (
                                          <span
                                            key={employee.id}
                                            className="avatar avatar-rounded"
                                          >
                                            <img
                                              className="border border-white"
                                              src={employee.PictureURL ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                                              alt={employee.name}
                                              title={employee.name}
                                            />
                                          </span>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xl-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-header">
                      <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                        <h5>My Skills</h5>
                      </div>
                    </div>
                    <div className="card-body">
                      {employeeFullDetails?.skills?.map((skill: any) => (
                        <div
                          key={skill.Id}
                          className="border border-dashed bg-transparent-light rounded p-2 mb-2"
                        >
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                              <span
                                className="d-block border border-2 h-12 rounded-5 me-2"
                                style={{ borderColor: "primary" }}
                              />
                              <div>
                                <h6 className="fw-medium mb-1">
                                  {skill.SkillName}
                                </h6>
                                <p>
                                  Updated :{" "}
                                  {new Date(skill.ModifiedAt).toLocaleDateString()}
                                </p>
                              </div>
                            </div>
                            <CircleProgressSmall
                              value={(skill.ProficiencyScore / 10) * 100}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 d-flex">
                  <div className="flex-fill">
                    {birthday && birthday.length > 0 ? (
                      birthday?.map((employee: any) => (
                        <div
                          className="card card-bg-5 bg-dark mb-3"
                          key={employee.EmployeeID}
                        >
                          <div className="card-body">
                            <div className="text-center">
                              <h5 className="text-white mb-4">Team Birthday</h5>
                              <span className="avatar avatar-xl avatar-rounded mb-2">
                                <img
                                  src={
                                    employee.PictureURL ??
                                    "https://cdn-icons-png.flaticon.com/512/149/149071.png"
                                  }
                                  alt={employee.Name}
                                />
                              </span>
                              <div className="mb-3">
                                <h6 className="text-white fw-medium mb-1">
                                  {employee.Name}
                                </h6>
                                <p>{employee.DesignationName || "Team Member"}</p>
                                <p><span>Month-Date /</span>{employee.dob_md || "Team Member"}</p>
                              </div>
                              {/* <Link to="#" className="btn btn-sm btn-primary">
                            Send Wishes
                          </Link> */}
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div
                        className="card card-bg-5 bg-dark mb-3"
                      >
                        <div className="card-body">
                          <div className="text-center">
                            <h5 className="text-white mb-4">No Team's Birthday</h5>
                            <span className="avatar avatar-xl avatar-rounded mb-2">
                              <img
                                src={
                                  "https://cdn-icons-png.flaticon.com/512/149/149071.png"
                                }
                                alt={""}
                              />
                            </span>
                            <div className="mb-3">
                              <h6 className="text-white fw-medium mb-1">
                                {" "}
                              </h6>
                            </div>
                            {/* <Link to="#" className="btn btn-sm btn-primary">
                          Send Wishes
                        </Link> */}
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="card bg-warning">
                      <div className="card-body d-flex align-items-center justify-content-between p-3">
                        <div>
                          <h5 className="mb-1">Next Holiday - {nextUpcomingHoliday?.HolidayType}</h5>

                          {nextUpcomingHoliday ? (
                            <p className="text-gray-9">
                              {nextUpcomingHoliday.Name},{" "}
                              {getDateRange(
                                nextUpcomingHoliday.StartDate,
                                nextUpcomingHoliday.EndDate
                              ).join(", ")}
                            </p>
                          ) : (
                            <p className="text-gray-9">No upcoming holidays</p>
                          )}

                        </div>

                        <Link
                          to={all_routes.holidays}
                          className="btn btn-white btn-sm px-3"
                        >
                          View All
                        </Link>
                      </div>
                    </div>

                  </div>
                </div>
                <div className="col-xl-12">
                  <div className="card flex-fill">
                    <div className="card-header">
                      <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                        <h5 className="mb-0">My Policy</h5>
                      </div>
                    </div>
                    <div className="card-body">
                      '{employeepolicy && employeepolicy.length > 0 ? (
                        <div className="row g-3">
                          {employeepolicy?.map((policy: any, index: number) => {
                            const isPublic = policy.public === 1;
                            const privateAccess = policy.privateAccess || [];

                            const canView = isPublic || privateAccess.includes("view");
                            const canDownload = isPublic || privateAccess.includes("download");

                            return (
                              <div key={policy.Id} className="col-md-6 col-lg-4">
                                <div className="card h-100 shadow-sm">
                                  <div className="card-body d-flex flex-column">
                                    <h6 className="fw-semibold mb-2">{index + 1}. {policy.Name}</h6>
                                    <p className="text-muted small mb-2">{policy.Description}</p>
                                    <div className="text-muted small mb-3">
                                      <strong>Effective Date:</strong> {policy?.EffectiveDate.split("T")[0]}
                                    </div>

                                    <div className="mt-auto d-flex justify-content-between">
                                      {/* View button */}
                                      <button
                                        className="btn btn-sm btn-primary"
                                        onClick={() => canView && openPolicyViewer(policy)}
                                        disabled={!canView}
                                      >
                                        <i className="ti ti-eye me-1" /> View
                                      </button>

                                      {canDownload ? (
                                        <button
                                          className="btn btn-sm btn-outline-success"
                                          onClick={() => handlePolicyDownload(policy)}
                                        >
                                          <i className="ti ti-download me-1" /> Download
                                        </button>
                                      ) : (
                                        <button
                                          className="btn btn-sm btn-outline-success disabled"
                                          style={{ pointerEvents: "none" }}
                                          type="button"
                                        >
                                          <i className="ti ti-download me-1" /> Download
                                        </button>
                                      )}

                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <div className="text-center text-muted">No policies available</div>
                      )}'
                    </div>
                  </div>

                </div>
                <div className="col-xl-12">
                  <div className="card flex-fill">
                    <div className="card-header">
                      <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                        <h5 className="mb-0">My Assets</h5>
                      </div>
                    </div>
                    <div className="card-body">
                      {assetAllocationsByEmployee && assetAllocationsByEmployee.length > 0 ? (
                        <div className="row g-3">
                          {assetAllocationsByEmployee?.map((asset: any, index: number) => (
                            <div key={asset.allocation_id} className="col-md-6 col-lg-4">
                              <div className="card h-100 shadow-sm">
                                <div className="card-body d-flex flex-column">
                                  {/* Asset Image */}
                                  <div className="text-center mb-3">
                                    <img
                                      src={asset.EmployeePicture ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                                      alt={asset.AssetName}
                                      className="rounded-circle"
                                      style={{ width: "80px", height: "80px", objectFit: "cover" }}
                                    />
                                  </div>

                                  {/* Asset Info */}
                                  <h6 className="fw-semibold mb-2">{asset.AssetName}</h6>
                                  <p className="text-muted small mb-1"><strong>Serial No:</strong> {asset.serial_number}</p>
                                  <p className="text-muted small mb-1"><strong>Allocated To:</strong> {asset.EmployeeName}</p>
                                  <p className="text-muted small mb-1"><strong>Status:</strong> {asset.allocation_status}</p>
                                  <p className="text-muted small mb-1">
                                    <strong>Allocated At:</strong> {asset.allocated_at?.split("T")[0]}
                                  </p>
                                  <p className="text-muted small mb-1">
                                    <strong>Expected Return:</strong> {asset.expected_return_date?.split("T")[0]}
                                  </p>

                                  {/* Optional Remarks */}
                                  {asset.remarks && (
                                    <p className="text-muted small mb-1"><strong>Remarks:</strong> {asset.remarks}</p>
                                  )}

                                  {/* Action Buttons (if any in future) */}
                                  <div className="mt-auto d-flex justify-content-end gap-2">
                                    {/* Example: View or Return buttons */}
                                    {/* <button className="btn btn-sm btn-outline-primary">View</button> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="text-center text-muted">No assets allocated</div>
                      )}
                    </div>
                  </div>
                </div>

                <Modal
                  open={isPolicyViewerOpen}
                  onCancel={closePolicyViewer}
                  footer={null}
                  destroyOnHidden
                  maskClosable={false}
                  width="60%"
                  styles={{ body: { padding: 0, height: "60vh" } }}
                  title={activePolicy?.PolicyDocName || "Policy Document"}
                >
                  {activePolicy && (
                    <div
                      className="policy-viewer"
                      style={{ position: "relative", width: "100%", height: "100%" }}
                    >
                      <embed
                        src={`${activePolicy.PolicyDocURL}#toolbar=0&navpanes=0&statusbar=0&scrollbar=0&messages=0&view=FitH`}
                        type="application/pdf"
                        style={{ width: "100%", height: "100%", border: "none", display: "block" }}
                        draggable={false}
                      />
                      <div
                        ref={overlayGuardRef}
                        tabIndex={0}
                        onKeyDown={(e) => {
                          const k = e.key.toLowerCase();
                          if ((e.ctrlKey || e.metaKey) && (k === "p" || k === "s")) {
                            e.preventDefault();
                            e.stopPropagation();
                            alert("Printing is disabled.");
                          }
                        }}
                        onContextMenu={(e) => { e.preventDefault(); e.stopPropagation(); }}
                        onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
                        onMouseUp={(e) => { e.preventDefault(); e.stopPropagation(); }}
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
                        onAuxClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
                        onPointerDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: "17px",
                          bottom: 0,
                          zIndex: 50,
                          background: "transparent",
                          cursor: "not-allowed",
                        }}
                      />
                      {activePolicy?.privateAccess?.length === 1 &&
                        activePolicy.privateAccess.includes("view") && (
                          <div
                            style={{
                              position: "absolute", inset: 0, zIndex: 60,
                              pointerEvents: "none", background: "transparent",
                            }}
                          >
                            <div
                              style={{
                                position: "absolute",
                                top: "50%", left: "50%",
                                transform: "translate(-50%, -50%) rotate(-30deg)",
                                fontSize: "3rem",
                                color: "rgba(0,0,0,0.15)",
                                fontWeight: "bold",
                                userSelect: "none",
                              }}
                            >
                              Confidential • View Only
                            </div>
                          </div>
                        )}
                    </div>
                  )}
                </Modal>
              </div>
            </>
          ) : (
            <EmployeeDashTeam />
          )}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025 © hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      <LeaveRequestModal
        modalType={modalType}
        isModalVisible={isModalVisible}
        handleCancel={handleCancel}
        employeeId={employeeId}
        employeeassignleave={employeeassignleave}
        checkWeeklyOffRange={checkWeeklyOffRange}
      />
      <PayslipModal isPaySlipModalVisible={isPaySlipModalVisible} setIsPaySlipModalVisible={setIsPaySlipModalVisible} selectedRowData={selectedRowData} downloadPayslipAsPDF={downloadPayslipAsPDF} />
    </>
  );
};

export default EmployeeDashboard;
